module.exports = __webpack_public_path__ + "img/upload-error-alt.ef128718.svg";